//import 'reflect-metadata';
//import 'zone.js';
//import 'bootstrap';
import './polyfills';
//import '@azure/msal-angular';
//import '@progress/telerik-angular-report-viewer';
//import 'libphonenumber-js';
//import '../wwwroot/dist/style.css';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//if (module.hot) {
//    module.hot.accept();
//    module.hot.dispose(() => {
//        // Before restarting the app, we create a new root element and dispose the old one
//        const oldRootElem = document.querySelector('app');
//        const newRootElem = document.createElement('app');
//        oldRootElem!.parentNode!.insertBefore(newRootElem, oldRootElem);
//        modulePromise.then(appModule => appModule.destroy());
//    });
//} else {
//    enableProdMode();
//}
if (environment.production) {
    enableProdMode();
}

// Note: @ng-tools/webpack looks for the following expression when performing production
// builds. Don't change how this line looks, otherwise you may break tree-shaking.
//const modulePromise = platformBrowserDynamic().bootstrapModule(AppModule);
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
